// IotDashboard.js

import React, { useState, useEffect } from 'react';
import Header from '../homepage/header';
import './iotdashboard.css';

const FORENSICS_URL = process.env.REACT_APP_FORENSICS_URL || (
    window.location.protocol === 'https:'
        ? `${window.location.origin}/forensics`
        : `http://${window.location.hostname}:8000`
);

function IotDashboard() {
    const [forensicsOnline, setForensicsOnline] = useState(null); // null = checking

    // Check if the forensics server is reachable
    useEffect(() => {
        const checkServer = async () => {
            try {
                const res = await fetch(`${FORENSICS_URL}/api/health`, {
                    method: 'GET',
                    signal: AbortSignal.timeout(3000),
                });
                setForensicsOnline(res.ok || res.status === 401);
            } catch {
                setForensicsOnline(false);
            }
        };
        checkServer();
        // Re-check every 15 seconds
        const interval = setInterval(checkServer, 15000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="iot-dashboard">
            <Header />


            {/* ── Content ──────────────────────────────────────────────── */}
            <div className="iot-tab-content">
                <div className="iot-panel panel-active">
                    {forensicsOnline === false ? (
                        <div className="forensics-offline-screen">
                            <div className="offline-icon">🔌</div>
                            <h3>AI Forensics Server is Offline</h3>
                            <p>
                                The AI Cyber Forensics backend is not running.<br />
                                Start it by running <code>start.bat</code> inside the Forensics Workshop folder:
                            </p>
                            <div className="offline-path-box">
                                <code>D:\AI-Cyber-Forensics-Workshop\AI-Cyber-Forensics-Workshop\start.bat</code>
                            </div>
                            <p className="offline-hint">
                                The server starts on <strong>http://127.0.0.1:8000</strong>.<br />
                                This page auto-checks every 15 seconds.
                            </p>
                            <button
                                className="retry-btn"
                                onClick={async () => {
                                    setForensicsOnline(null);
                                    try {
                                        const res = await fetch(`${FORENSICS_URL}/api/health`, {
                                            signal: AbortSignal.timeout(3000),
                                        });
                                        setForensicsOnline(res.ok || res.status === 401);
                                    } catch {
                                        setForensicsOnline(false);
                                    }
                                }}
                            >
                                🔄 Retry Connection
                            </button>
                        </div>
                    ) : forensicsOnline === null ? (
                        <div className="forensics-offline-screen">
                            <div className="offline-icon spin">⚙️</div>
                            <h3>Connecting to Forensics Server…</h3>
                        </div>
                    ) : (
                        <div className="forensics-iframe-wrapper">
                            <div className="forensics-toolbar">
                                <span className="forensics-toolbar-title">
                                    🛡️ AI Cyber Forensics &amp; DFIR Toolkit
                                </span>
                                <a
                                    href={FORENSICS_URL}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="open-external-btn"
                                >
                                    ↗ Open Full Screen
                                </a>
                            </div>
                            <iframe
                                src={FORENSICS_URL}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                title="AI Cyber Forensics Dashboard"
                                allowFullScreen
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default IotDashboard;